import CheckboxFieldV2 from '@/components/common/form/fields/CheckboxFieldV2';
import PhoneFieldV2, { PhoneFieldV2Props } from '@/components/common/form/fields/PhoneFieldV2';
import PostalCodeFieldV2, { PostalCodeFieldV2Props } from '@/components/common/form/fields/PostalCodeFieldV2';
import SelectFieldV2, { SelectFieldV2Props } from '@/components/common/form/fields/SelectFieldV2';
import TextFieldV2, { TextFieldV2Props } from '@/components/common/form/fields/TextFieldV2';
import { FIELD_TYPE, SUPPORTED_TYPES } from '@/constants/form';

const FIELDS_COMPONENT = {
  [FIELD_TYPE.CHECKBOX]: CheckboxFieldV2,
  [FIELD_TYPE.PHONE]: PhoneFieldV2,
  [FIELD_TYPE.POSTAL_CODE]: PostalCodeFieldV2,
  [FIELD_TYPE.SELECT]: SelectFieldV2,
  [FIELD_TYPE.TEXT]: TextFieldV2
};

type FormFieldV2Props =
  PhoneFieldV2Props
  & PostalCodeFieldV2Props
  & SelectFieldV2Props
  & TextFieldV2Props;

export const FormFieldV2 = (props: FormFieldV2Props): React.JSX.Element => {
  const { type, ...rest } = props;
  const Component = FIELDS_COMPONENT[type];

  if (!SUPPORTED_TYPES.includes(type)) {
    throw new Error(`The input type "${type}" is not handled`);
  }

  return (
    <Component {...rest} />
  );
};

export default FormFieldV2;
